import React from 'react'

export default function Footer({webpreview}) {
    return (
        <>
            <footer>
                <div className="container">
                    <div className="row">
                        <div className="col-xs-12">
                            <div className="copyright text-center">
                                <p>{webpreview && webpreview.business_name} © Copyright . All Rights Reserved.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}
